import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { CategoryWithParts, ILeadPartsTableGlobalFilters } from "../../../../models/Part";
import { PartCategoryConflictMap } from "../../../../models/PartCategorySubPart";
import LeadPartsCategoriesTable from "./LeadPartsCategoriesTable";
import { IVehicle } from "../../../../models/Vehicle";

interface ManualLeadPartCategoriesProps {
  selectedCategories: CategoryWithParts[] | undefined;
  handleTableSelectionChange: (tableId: string, update: CategoryWithParts[] | ((prev: CategoryWithParts[]) => CategoryWithParts[])) => void;
  partProUnlocked: boolean;
  partProLoading: boolean;
  vehicle: IVehicle;
  filter?: (cat: CategoryWithParts) => boolean;
  leadPartsTableFilters: ILeadPartsTableGlobalFilters;
  showBestPrice?: boolean;
  /** Global (cross-table) main/sub-part clashes, keyed by category id. */
  categoryConflicts?: PartCategoryConflictMap;
}

export default function ManualLeadPartCategories({
  selectedCategories,
  handleTableSelectionChange,
  partProUnlocked,
  partProLoading,
  vehicle,
  filter,
  leadPartsTableFilters,
  showBestPrice = false,
  categoryConflicts,
}: ManualLeadPartCategoriesProps) {
  const { t } = useTranslation("leads");

  const manualCategories = useMemo(() => {
    // No parts means it's a manual, but also need to make sure it's not from the lookup
    return selectedCategories?.filter(cat => cat.isManual)
  }, [selectedCategories]);

  if (!selectedCategories || selectedCategories.length === 0) {
    return null;
  }

  if (manualCategories?.length === 0) {
    return null;
  }


  return (
    <div className="">
      <h2 className="font-semibold">{t("Manual Categories")}</h2>
      <LeadPartsCategoriesTable
        categories={manualCategories ?? []}
        selectedCategories={manualCategories}
        setSelectedCategories={(update) => handleTableSelectionChange("manual", update)}
        partProUnlocked={partProUnlocked}
        partProLoading={partProLoading}
        vehicle={vehicle}
        filter={filter}
        leadPartsTableFilters={leadPartsTableFilters}
        showBestPrice={showBestPrice}
        categoryConflicts={categoryConflicts}
      />
    </div>
  )
}